export const CORRECT_CHAIN_FOR_AIRDROP = {
    name: process.env.VUE_APP_LQF_GIVEAWAY_CONTRACT_IN_NETWORK_NAME,
    chainId: +process.env.VUE_APP_LQF_GIVEAWAY_CONTRACT_IN_NETWORK_ID
};
